import api from "./api"
import { AxiosError } from "axios"
import { ExtendedWalkReport, WalkReport } from "../Interfaces";

class WalkService {
  private baseUrl = "/walk";

  public create = async (walkInfo: any) => {
    if (!walkInfo) throw new Error("No walk info provided")
    try {
      const response = await api.post(
        `${this.baseUrl}`,
        walkInfo,
      );
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error(error.response);
        throw Error(error.response?.statusText)
      } else {
        console.error(error);
      }
      return null;
    }
  }

  public getOne = async (id: number) => {
    if (!id) throw new Error("No id provided")
    try {
      const response = await api.get(
        `${this.baseUrl}/${id}`
      );
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error(error.response);
        throw Error(error.response?.statusText)
      } else {
        console.error(error);
      }
      return null;
    }
  }

  public getOneReport = async (walkReportId: number): Promise<ExtendedWalkReport> => {
    try {
      const response = await api.get(
        `${this.baseUrl}/walk-report/${walkReportId}`
      );
      return response.data
    } catch (error) {
      console.error("getOneReport error:", error)
      if (error instanceof AxiosError) {
        console.error("getOneReport Axios error response:", error.response?.data)
        console.error("getOneReport Axios error status:", error.response?.status)
        throw Error("axios error")
      } else {
        console.error("getOneReport non-Axios error:", error);
      }
    }
    return {} as ExtendedWalkReport
  }

  public getAllByLocation = async (locationId: number) => {
    try {
      const response = await api.get(
        `${this.baseUrl}/all/${locationId}`
      );
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error(error.response);
        throw Error(error.response?.statusText)
      } else {
        console.error(error);
      }
      return null;
    }
  }

  public getAll = async (locationId: number | null) => {
    if (!locationId) return null;
    try {
      const response = await api.get(
        `${this.baseUrl}/all/${locationId}`
      );
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error(error.response);
        throw Error(error.response?.statusText)
      } else {
        console.error(error);
      }
      return null;
    }
  }

  public getSomeReportsByLocation = async (locationId: number, limit: number, page: number, searchTerm?: string): Promise<{ walkReports: WalkReport[]; totalCount: number }> => {
    try {
      const response = await api.get(
        `${this.baseUrl}/some/by-location/${locationId}?limit=${limit}&offset=${page}&searchTerm=${searchTerm || ""}`
      );
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error(error.response);
        throw Error(error.response?.statusText)
      } else {
        console.error(error);
      }
      return { walkReports: [], totalCount: 0 };
    }
  }

  public getViewableMarkerImage = async (walkReportId: number, markerId: number, key: string) => {
    try {
      const { data: signedUrl } = await api.get(
        `${this.baseUrl}/photo/${walkReportId}/${markerId}/${key}`,
      )
      return signedUrl;
    } catch (error) {
      return error as Error;
    }
  }

  public update = async (walkInfo: any) => {
    try {
      const response = await api.put(
        `${this.baseUrl}`,
        walkInfo
      );
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error(error.response);
        throw Error(error.response?.statusText)
      } else {
        console.error(error);
      }
      return null;
    }
  }

  public delete = async (id: number) => {
    if (!id) throw new Error("No id provided")
    try {
      const response = await api.delete(
        `${this.baseUrl}/${id}`
      );
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error(error.response);
        throw Error(error.response?.statusText)
      } else {
        console.error(error);
      }
      return null;
    }
  }
}

export const walkService = new WalkService()